import { useLocalization } from "./useLocalization";
import { Localization, Months, WeekDays } from "../types/types";

export const useDate = () => {
  const { locale, strings } = useLocalization();

  return (JSONDate: string): string => {
    if (!Date.parse(JSONDate)) return "";

    const formattedDate = new Date(JSONDate);
    const dayInt = formattedDate.getDay();
    const dateKey = WeekDays[dayInt] as keyof typeof strings.WEEKDAYS;

    const weekday = strings.WEEKDAYS[dateKey].toUpperCase();
    const monthInt = formattedDate.getMonth();
    const monthKey = Months[monthInt] as keyof typeof strings.MONTHS;
    const rawHours = formattedDate.getHours();
    const minutes = formattedDate.getMinutes().toString().padStart(2, "0");

    if (locale === Localization.Finnish) {
      const month = strings.MONTHS[monthKey].replace("kuu", "");
      return `${weekday} \n${formattedDate.getDate().toString()}. ${month} ${formattedDate.getFullYear().toString().substring(2, 4)} ${formattedDate.getHours().toString()}:${minutes}`;
    } else {
      const period = rawHours >= 12 ? "PM" : "AM";
      const hours = (rawHours % 12 || 12).toString();
      return `${weekday} \n${formattedDate.getDate().toString()}. ${strings.MONTHS[monthKey].substring(0, 3).toUpperCase()} ${formattedDate.getFullYear().toString().substring(2, 4)} ${hours}:${minutes} ${period}`;
    }
  };
};
